export default "__VITE_ASSET__D6jDPc9L__"